export default __webpack_public_path__ + "static/media/usericn.531da4a0.svg";